import { ToastOptions, toast } from "react-toastify";


const showMesage = (message: string, isStatic?: boolean, isSuccess?:boolean): void => {

    const toastOptions: ToastOptions = {
        position: 'top-right',
        autoClose: isStatic ? false : 10000,
        closeOnClick: true,
        bodyStyle: {
            margin: '5px', whiteSpace: 'pre-line', fontSize: '14px',
        },
        delay: 0
    };

    if (isSuccess) {
        toast.success(message, toastOptions);
    }
    else {
        toast.error(message, toastOptions);
    }
}


const messageHelper = {
    showMesage
}

export default messageHelper;
